import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Activity"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 21.75C8.69722 21.7485 8.42505 21.5651 8.31 21.285L4.7475 12.75H1.5V11.25H5.25C5.55278 11.2515 5.82495 11.4349 5.94 11.715L9 18.96L15.045 2.7375C15.1548 2.4435 15.4361 2.24898 15.75 2.25C16.0669 2.25554 16.3461 2.4597 16.4475 2.76L19.29 11.25H22.5V12.75H18.75C18.4276 12.7508 18.1407 12.5455 18.0375 12.24L15.75 5.25L9.705 21.2625C9.59515 21.5565 9.31385 21.751 9 21.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Activity.vue"]]);
